import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
  .mandatory-msg {
    margin-left: 0.5rem;
    font-size: 0.875rem;
  }
  .hefesto-textarea {
    width: 100%;
  }
`;

export const WarningMessage = styled.span`
  margin-top: 0.5rem;
  margin-left: 0.5rem;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.red2};
  & > .hefesto-icon {
    width: 1rem;
    height: 1rem;
    margin-right: 0.3rem;
    & > svg {
      width: 1rem;
      height: 1rem;
    }
  }
`;
